import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import './Navbar.css';

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
    setProductsOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { 
      label: 'QC-Metric', 
      dropdown: [
        { path: '/products/qc-metric', label: 'Overview' },
        { path: '/products/content-management', label: 'Content Management' },
        { path: '/products/training-management', label: 'Training Management' },
        { path: '/products/quality-management', label: 'Quality Management' },
        { path: '/products/workflow-forms', label: 'Workflow Based Forms' },
      ]
    },
    { path: '/industries', label: 'Industries' },
    { path: '/careers', label: 'Careers' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src="/logo.png" alt="Aurexa Technologies" />
        </Link>

        <div className={`navbar-menu ${isOpen ? 'active' : ''}`}>
          {navLinks.map((link, index) => (
            link.dropdown ? (
              <div 
                key={index} 
                className={`nav-item dropdown ${productsOpen ? 'open' : ''}`}
                onMouseEnter={() => setProductsOpen(true)}
                onMouseLeave={() => setProductsOpen(false)}
              >
                <button className="nav-link dropdown-toggle">
                  {link.label}
                  <ChevronDown size={16} />
                </button>
                <div className="dropdown-menu">
                  {link.dropdown.map((item, idx) => (
                    <Link key={idx} to={item.path} className="dropdown-item">
                      {item.label}
                    </Link>
                  ))}
                </div>
              </div>
            ) : (
              <Link 
                key={index} 
                to={link.path} 
                className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
              >
                {link.label}
              </Link>
            )
          ))}
        </div>

        <div className="navbar-actions">
          <Link to="/demo" className="btn btn-primary">
            Book a Demo
          </Link>
          <button 
            className="navbar-toggle" 
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
